import { render, staticRenderFns } from "./selected-cn-dn.vue?vue&type=template&id=631d3f20"
import script from "./selected-cn-dn.vue?vue&type=script&lang=js"
export * from "./selected-cn-dn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports